<template>
  <div class="c-row" :class="rowClass" :style="rowStyle">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "CRow",
    props: {
      gutter: {
        type: [Number, String]
      },
      align: {
        type: String,
        default: "left",
        validator(val) {
          return ["left", "center", "right"].includes(val);
        }
      }
    },
    computed: {
      rowStyle() {
        let {gutter} = this;
        return {
          marginLeft: -gutter / 2 + "px",
          marginRight: -gutter / 2 + "px"
        };
      },
      rowClass() {
        let {align} = this;
        return [align && `align-${align}`];
      }
    },
    mounted() {
      this.$children.forEach(vm => {
        vm.gutter = this.gutter;
      });
    }
  };
</script>

<style lang="scss" scoped>
  .c-row {
    display: flex;
    width: 100%;
    height: 100%;
    &.align-left {
      justify-content: flex-start;
    }
    &.align-center {
      justify-content: center;
    }
    &.align-right {
      justify-content: flex-end;
    }
  }
</style>
